<template>
  <div>
    <div class="mt-4 mb-4">
      <!-- Param Modal  -->
      <b-modal
        id="modal-param"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="xl"
        :title="titleModalParam"
      >
        <template #default>
          <alert-error
            v-if="formParam.errors.get('message')"
            :form="formParam"
            :message="formParam.errors.get('message')"
          ></alert-error>
          <form
            @submit.prevent="submitParam"
            @keydown="formParam.onKeydown($event)"
          >
            <div class="row pt-3">
              <div
                v-if="modeParam === 'create'"
                class="col-12 d-flex justify-content-end"
              >
                <button
                  @click="ajouterParam"
                  type="button"
                  class="btn btn-custom-primary"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
              <div
                class="row col-12"
                v-for="(param, index) in formParam.params"
                :key="index"
              >
                <div class="col-md-12 col-lg-4 mt-n4">
                  <div class="form-group">
                    <label for="cle"
                      >Clé <span class="text-danger">*</span></label
                    >
                    <v-custom-select
                      :required="modeParam !== 'show'"
                      :disabled="modeParam !== 'create'"
                      label="cle"
                      id="cle"
                      :options="cleParams"
                      :reduce="(c) => c.uuid"
                      v-model="formParam.params[index].cle"
                      placeholder="clé"
                    >
                      <template v-slot:option="{ cle }">
                        <h5 style="margin: 0">{{ cle }}</h5>
                      </template>
                      <template #no-options> Aucune donnée </template>
                      <template #search="{ attributes, events }">
                        <input
                          id="cle"
                          class="custom-select-height vs__search"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-custom-select>
                    <input
                      type="hidden"
                      class="form-control"
                      :class="{
                        'is-invalid': formParam.errors.has(
                          `params.${index}.cle`
                        ),
                      }"
                    />
                    <span
                      v-if="formParam.errors.has(`params.${index}.cle`)"
                      class="text-danger small"
                      >{{
                        formatError(formParam.errors.get(`params.${index}.cle`))
                      }}</span
                    >
                  </div>
                </div>

                <div class="col-md-12 col-lg-7 mt-n4">
                  <div class="form-group">
                    <label for="valeur"
                      >Valeur (max : 100 caractères )
                      <span class="text-danger">*</span></label
                    >
                    <textarea
                      id="valeur"
                      v-model="formParam.params[index].valeur"
                      class="form-control"
                      :class="{
                        'is-invalid': formParam.errors.has(
                          `params.${index}.valeur`
                        ),
                      }"
                      rows="2"
                      maxlength="100"
                      :required="modeParam !== 'show'"
                      :disabled="modeParam === 'show'"
                    ></textarea>
                    <span
                      v-if="formParam.errors.has(`params.${index}.valeur`)"
                      class="text-danger small"
                      >{{
                        formatError(
                          formParam.errors.get(`params.${index}.valeur`)
                        )
                      }}</span
                    >
                  </div>
                </div>
                <div
                  v-if="modeParam === 'create'"
                  class="col-md-12 col-lg-1 mt-n4 d-flex align-items-center justify-content-center"
                >
                  <button type="button" @click="enleverParam(index)">
                    <i class="fas fa-trash fa-lg-2x text-danger"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </template>
        <template #modal-footer>
          <button
            type="button"
            class="btn btn-danger mr-2"
            @click="$bvModal.hide('modal-param')"
          >
            Fermer
          </button>

          <button
            v-if="modeParam !== 'show'"
            type="submit"
            class="btn btn-custom-primary w-40"
            @click="submitParam"
            style="min-width: 100px"
          >
            {{ modeParam === 'create' ? 'Créer' : 'Enregistrer' }}
          </button>
        </template>
      </b-modal>

      <div class="row">
        <div class="col-md-12">
          <!-- Autre informations -->

          <div class="row mb-1">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-custom-primary"
                @click="showParamModal(null)"
              >
                <i class="fas fa-plus"></i>
                Nouvelle info
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelectionParam"
                v-show="isSelectParam"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ParamDataTable
                ref="datatableParam"
                @onSelect="onSelectParamRows"
                @onRowShow="showParamModal"
                @onRowEdit="editParamModal"
                @onRowsDelete="deleteParamRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/crm/tiers_contact/tiers';
import ParamDataTable from './DataTable.vue';

import From from 'vform';
export default {
  data() {
    return {
      formParam: new From({
        params: [],
      }),
      currentTiers: '',

      // Pour la nouvelle cle-valeur qui sera ajoutee a formParam.params
      newParam: {
        cle: '',
        valeur: '',
      },
      cleParams: [], // pour les cles que l'utilisateur va selectionner

      modeParam: 'create',
      titleModalParam: 'Ajout de nouvelle clé-valeur',
      isSelectParam: false,
    };
  },
  components: {
    ParamDataTable,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    /**
     * Modal param
     */
    async showParamModal(id) {
      if (id) {
        this.titleModalParam = "Aperçu d'une info";
        this.formParam.reset();
        this.formParam.clear();
        this.modeParam = 'show';

        await window.axios
          .all([
            window.axios.get(URL.TIERS_PARAM + '/' + id),
            window.axios.get(URL.TIERS_PARAM_REQUIREMENTS),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              let tiersParam = resp1.data.tiersParam;
              this.formParam.params.push({
                cle: tiersParam.cle,
                valeur: tiersParam.valeur,
              });
              this.cleParams = resp2.data.cleParams;
            })
          )
          .catch();
      } else {
        this.modeParam = 'create';
        this.titleModalParam = 'Ajout de nouvelle info';
        this.formParam.reset();
        this.formParam.clear();
        await window.axios
          .get(URL.TIERS_PARAM_REQUIREMENTS + '/' + this.currentTiers.id)
          .then((resp) => {
            this.cleParams = resp.data.cleParams;
          })
          .catch();
      }

      await this.$bvModal.show('modal-param');
    },
    async editParamModal(id) {
      this.titleModalParam = "Edition d'une info";
      this.formParam.reset();
      this.formParam.clear();
      this.modeParam = 'edit';

      await window.axios
        .all([
          window.axios.get(URL.TIERS_PARAM + '/' + id),
          window.axios.get(URL.TIERS_PARAM_REQUIREMENTS),
        ])
        .then(
          window.axios.spread((resp1, resp2) => {
            this.formParam.params.push({ ...resp1.data.tiersParam });
            this.cleParams = resp2.data.cleParams;
          })
        )
        .catch();

      await this.$bvModal.show('modal-param');
    },
    submitParam() {
      this.formParam.tiers = this.currentTiers.uuid;
      this.$bvModal.hide('modal-param');
      if (this.formParam.id) {
        //update
        this.formParam
          .put(URL.TIERS_PARAM + '/' + this.formParam.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.formParam.reset();
            this.formParam.clear();
            this.$refs.datatableParam.loadItems();
          })
          .catch((err) => {
            this.formParam.errors.set('message', err.response.data.message);
            this.$bvModal.show('modal-param');
          });
      } else {
        //store
        this.formParam
          .post(URL.TIERS_PARAM)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);

            this.formParam.reset();
            this.formParam.clear();
            this.$refs.datatableParam.loadItems();
          })
          .catch((err) => {
            this.formParam.errors.set('message', err.response.data.message);
            this.$bvModal.show('modal-param');
          });
      }
    },
    onSelectParamRows(isSelectParam) {
      this.isSelectParam = isSelectParam;
    },
    deleteAllSelectionParam() {
      this.deleteParamRows(this.$refs.datatableParam.idsRowsSelected);
    },
    deleteParamRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.TIERS_PARAM, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatableParam.loadItems();
                this.isSelectParam = false;
              })
              .catch();
          }
        });
      }
    },

    ajouterParam() {
      this.formParam.params.push({ cle: '', valeur: '' });
    },
    enleverParam(i) {
      this.formParam.params.splice(i, 1);
      this.formParam.errors.clear();
    },

    formatError(errMessage) {
      let match = null;
      let pattern = /\s+\w+\.\d+\.(\w+)\s+/i;
      try {
        if ((match = errMessage.match(pattern))) {
          return errMessage.replace(pattern, ` ${match[1]} `);
        }
      } catch {
        return errMessage;
      }

      return errMessage;
    },

    /** FIN */
    init() {
      let id = this.$route.params.id;
      window.axios
        .get(URL.TIERS + '/' + id)
        .then((resp) => {
          this.currentTiers = resp.data.tiers;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
